import type { LocationDevice } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

export const DEFAULT_SERP_OVERLAY_TRACKING_EVENT = "View SERP";
export const SERP_OVERLAY_WITHIN_TOOLTIP_TRACKING_EVENT = `${DEFAULT_SERP_OVERLAY_TRACKING_EVENT}/Within tooltip`;

export const DEVICE_LABEL_KEYS: Record<LocationDevice, string> = {
    BOTH: "rankTracker.addKeywords.modal.allDevices",
    DESKTOP: "common.desktop",
    MOBILE: "common.mobile",
};
